const { API_URL } = process.env.REACT_APP_API_URL;
const { NODE_ENV } = process.env;
const API_KEY_DADATA = "bccf01d44b841d082101c119c72601851e259396";

export { API_URL, NODE_ENV, API_KEY_DADATA };
